function SplashScreen() {
  return (
    <div className="h-full w-full z-50 fixed top-0 left-0 flex justify-center items-center bg-black bg-opacity-50">
      <img src="/images/logo512.png" alt="" className="animate-fadeIn w-2/3" />
    </div>
  );
}

export default SplashScreen;
